import { useState, useEffect } from "react";
import useAxios from "../services/useAxios";
import { useParams } from "react-router";
import SingleProduct from "../components/product/SingleProduct.jsx";
import Loader from "../components/kits/Loader";
export default function SingleProductPage() {
  const { productId, shopId } = useParams();
  const [product, setProduct] = useState();
  const[updater1,setUpdater1]=useState(false)
  const { loading, execute: getSingleProduct } = useAxios(
    "api/get_single_product"
  );
  useEffect(() => {
    getSingleProduct({ avb_product_id: productId, supplier_id: shopId }).then(
      data => {
       data!=undefined&& setProduct(data);
      }
    );
  }, [updater1]);
  return loading ? (
    <div className="d-flex align-items-center justify-content-center h-100">
      <Loader width={40} />
    </div>
  ) : (
    <SingleProduct
      product={product}
      shopId={shopId}
      productId={productId}
      updater1={updater1}
      setUpdater1={setUpdater1}
    ></SingleProduct>
  );
}
